// Managed Agents usage in the usage hover (GRO-450). Agents bill in minutes and dollars, not credits,
// so they get their own rows beside the credits. Plain .ts so node --test can load it.

import { formatUsd } from './funding.ts';

export interface AgentUsageFields {
  agent_minutes_30?: number | null;
  agent_minutes_prior_30?: number | null;
  agent_usd_30?: number | null;
}

// Whole minutes with separators, "0" for none; a fraction of a minute shows as "<1".
export function formatMinutes(minutes: number | null | undefined): string {
  const value = minutes ?? 0;
  if (value > 0 && value < 1) return '<1';
  return Math.round(value).toLocaleString();
}

// "1,234 min · $56", or "None" when the account has no agents usage in the window.
export function agentUsageText(minutes: number | null | undefined, usd: number | null | undefined): string {
  if (!minutes && !usd) return 'None';
  const spend = formatUsd(usd);
  return `${formatMinutes(minutes)} min${spend ? ' · ' + spend : ''}`;
}

// The hover's two agents rows: this 30 days with spend, and the 30 before (minutes only).
export function agentUsageRows(row: AgentUsageFields): Array<[string, string]> {
  return [
    ['Agents 30d', agentUsageText(row.agent_minutes_30, row.agent_usd_30)],
    ['Agents previous 30d', row.agent_minutes_prior_30 ? `${formatMinutes(row.agent_minutes_prior_30)} min` : 'None'],
  ];
}
